<template>
  <div class="home-content">
    <div class="mine-header">
      <span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png" /></span>Bank Wallet
      <span class="add-wallet" @click="addWallet()"><img src="@/assets/images/base/add_icon.png" /></span>
    </div>
    <div class="third-pard">
      <div v-show="!nodata">
        <div class="list" v-for="(i, index) in list" v-bind:key="index">
          <ul>
            <li class="des">
              <div>Holder's Name</div>
              <div>{{ i.account_holder_name }}</div>
              <button v-clipboard:error="util.onError" v-clipboard:copy="i.account_holder_name"
                v-clipboard:success="util.onCopy">Copy</button>
            </li>
            <li class="des">
              <div>Bank Name</div>
              <div>{{ i.bank_name }}</div>
              <button v-clipboard:error="util.onError" v-clipboard:copy="i.bank_name"
                v-clipboard:success="util.onCopy">Copy</button>
            </li>
            <li class="des">
              <div>A/C No</div>
              <div>{{ i.bank_card_number }}</div>
              <button v-clipboard:error="util.onError" v-clipboard:copy="i.bank_card_number"
                v-clipboard:success="util.onCopy">Copy</button>
            </li>
            <li class="des">
              <div>IFSC Code</div>
              <div>{{ i.ifsc_account_number }}</div>
              <button v-clipboard:error="util.onError" v-clipboard:copy="i.ifsc_account_number"
                v-clipboard:success="util.onCopy">Copy</button>
            </li>
            <li class="des">
              <div>Contact No.</div>
              <div>{{ i.contact_info }}</div>
              <button v-clipboard:error="util.onError" v-clipboard:copy="i.contact_info"
                v-clipboard:success="util.onCopy">Copy</button>
            </li>
            <li class="des">
              <div>UPI ID</div>
              <div>{{ i.email_info }}</div>
              <button v-clipboard:error="util.onError" v-clipboard:copy="i.email_info"
                v-clipboard:success="util.onCopy">Copy</button>
            </li>
            <li class="des">
              <div>Remark</div>
              <div>{{ i.remark }}</div>
              <button v-clipboard:error="util.onError" v-clipboard:copy="i.remark"
                v-clipboard:success="util.onCopy">Copy</button>
            </li>
            <div class="edit-wallet">
              <button class="btn" @click="updateWallet(i)">Modify</button>
              <button class="btn" @click="delWallet(i.id)">Delete</button>
            </div>
          </ul>
        </div>
      </div>
      <div class="nodata" v-show="nodata"><img src="@/assets/images/icon/data_icon_219962.png" /><span>No data available</span></div>
      <div class="show-more" v-if="list.length >= 10" @click="showMore()">{{ hasMore ? "See more records, click here" : "No more data" }}</div>
    </div>
    <div class="edit-pard" v-if="isEdit">
      <div class="edit-head">
        <div @click="isEdit = false"><img src="@/assets/images/base/icon_righ_g.png" /></div>
        <div v-if="Object.keys(one).length === 0">Add Bank Wallet</div>
        <div v-else>Modify Bank Wallet</div>
        <div></div>
      </div>
      <div class="edit-content">
        <ul>
          <li>
            <div class="icon-input">Holder's Name</div>
            <input type="text" v-model="one.account_holder_name" placeholder="Please enter holder's name" />
          </li>
          <li>
            <div class="icon-input">Bank Name</div>
            <input type="text" v-model="one.bank_name" placeholder="Please enter bank name" />
          </li>
          <li>
            <div class="icon-input">A/C No</div>
            <input type="text" v-model="one.bank_card_number" onpaste="return false;" placeholder="Please enter A/C No" />
          </li>
          <li>
            <div class="icon-input">IFSC Code</div>
            <input type="text" v-model="one.ifsc_account_number" placeholder="Please enter IFSC Code" />
          </li>
          <li>
            <div class="icon-input">Contact No.</div>
            <input type="text" v-model="one.contact_info" placeholder="Please enter contact No." />
          </li>
          <li>
            <div class="icon-input">UPI ID</div>
            <input type="text" v-model="one.email_info" placeholder="Please enter UPI ID" />
          </li>
          <li>
            <div class="icon-input">Remark</div>
            <input type="text" v-model="one.remark" placeholder="Please enter remark" />
          </li>
          <li>
            <button class="btn-submit" v-show="!showloding" @click="submitbtn">Save</button>
            <button class="btn-submit" v-show="showloding">Save</button>
          </li>
        </ul>
      </div>
    </div>
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
/*global mui*/
import Vue from "vue";
import { Loading } from "vant";
Vue.use(Loading);
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
export default {
  data() {
    return {
      showloding: false,
      timeType: 1,
      nodata: true,
      status: 1,
      pageNo: 1,
      pageSize: 10,
      hasMore: true,
      list: [],
      one: {},
      isEdit: false,
    };
  },
  methods: {
    addWallet() {
      this.isEdit = true;
      this.one = {};
    },
    updateWallet(item) {
      this.isEdit = true;
      this.one = item;
    },
    submitbtn() {
      let re = /[^\d]/g;
      // eslint-disable-next-line no-useless-escape
      //let pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!this.one.bank_name) {
        mui.alert("Bank Name cannot be blank");
      } else if (!this.one.bank_card_number) {
        mui.alert("A/C No cannot be empty");
      } else if (re.test(this.one.bank_card_number)) {
        mui.alert("A/C No can only be numeric");
      }else if (!this.one.account_holder_name) {
        mui.alert("Holder's name cannot be empty");
      } else if (!this.one.ifsc_account_number) {
        mui.alert("IFSC Code cannot be empty");
      } else if (!this.one.contact_info) {
        mui.alert("Contact No. cannot be empty");
      } else if (!this.one.email_info) {
        mui.alert("UPI ID cannot be empty");
      } else if (!this.showloding) {
        if (this.one.id > 0) this.updateBankWallet();
        else this.addBankWallet();
      }
    },
    addBankWallet() {
      let params = {
        bank_name: this.one.bank_name,
        bank_card_number: this.one.bank_card_number,
        account_holder_name: this.one.account_holder_name,
        ifsc_account_number: this.one.ifsc_account_number,
        contact_info: this.one.contact_info,
        email_info: this.one.email_info,
        remark: this.one.remark
      };
      this.util.setDnValueToken(params);
      params.userId = this.util.user.user_id;
      this.axios.post(this.api.api_addBankWallet, this.util.encodeSearchParams(params))
        .then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            mui.toast("Add succeeded");
            this.isEdit = false;
            this.list = [];
            this.getWallet();
          } else {
            mui.toast(res.data.message);
          }
        })
        .catch(() => {
          this.showloding = false;
          mui.toast("Add failed");
        });
    },
    updateBankWallet() {
      let params = {
        walletId: this.one.id,
        bank_name: this.one.bank_name,
        bank_card_number: this.one.bank_card_number,
        account_holder_name: this.one.account_holder_name,
        ifsc_account_number: this.one.ifsc_account_number,
        contact_info: this.one.contact_info,
        email_info: this.one.email_info,
        remark: this.one.remark
      };
      this.util.setDnValueToken(params);
      this.axios.post(this.api.api_editBankWallet, this.util.encodeSearchParams(params))
        .then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            mui.toast("Modification succeeded");
            this.isEdit = false;
            this.list = [];
            this.getWallet();
          } else {
            mui.toast(res.data.message);
          }
        })
        .catch(() => {
          this.showloding = false;
          mui.toast("Modification failed");
        });
    },
    delWallet(id) {
      let _this = this;
      mui.confirm("Are you sure you want to delete this wallet?", "Hint", ["No", "Yes"], function (e) {
        if (e.index == 1) {
          _this.deleteOne(id);
        } else {
          mui.confirm();
        }
      });
    },
    deleteOne(id) {
      let params = { id: id };
      this.util.setDnValueToken(params);
      this.axios.post(this.api.api_deleteBankWallet, this.util.encodeSearchParams(params))
        .then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.list = [];
            this.getWallet();
          } else {
            mui.toast(res.data.message);
          }
        })
    },
    showMore() {
      if (this.hasMore) {
        this.pageNo += 1;
        this.getWallet();
      }
    },
    getWallet() {
      this.showloding = true;
      let params = {}
      this.util.setDnValueUser(params);
      this.axios.get(this.api.api_getBankWallet, { params: params }).then(res => {
          if (this.pageNo == 1) this.nodata = true;
          this.showloding = false;
          if (res.data.code == 0) {
            let list = res.data.data;
            if (list.length > 0) {
              this.nodata = false;
              this.list = this.list.concat(list);
            } else {
              this.hasMore = false;
            }
          } else {
            this.util.checkToken(res.data.message);
          }
        });
    },
  },
  activated() {
    if (this.util.isLogin()) {
      this.userInfo = this.util.user;
      this.list = [];
      this.getWallet();
    }
  }
};
</script>
<style lang="scss" scoped>
.home-content {
  font-size: 0.34rem;
  background: rgb(235, 235, 235);
  color: rgb(103, 103, 103);
  width: 100%;
  height: 100%;

  .mine-header {
    color: black;
    font-weight: bold;
    height: 1rem;
    display: grid;
    grid-template-columns: 30% 1fr 30%;
    align-items: center;
    text-align: center;

    .back {
      cursor: pointer;

      img {
        display: block;
        margin-left: 5%;
        width: 0.5rem;
        transform: rotate(180deg);
      }
    }

    .add-wallet {
      margin-top: 0;
      display: flex;
      justify-content: right;
      padding-right: 0.2rem;

      img {
        display: block;
        width: 0.7rem;
      }
    }
  }

  .third-pard {
    height: 100%;
    padding-bottom: 160px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    .nodata {
      margin-top: 50px;
      height: 50px;
      display: grid;
      justify-content: center;
      font-size: 0.32rem;

      img {
        display: block;
        width: 35px;
        margin: auto;
      }
    }

    .show-more {
      height: 50px;
      display: flex;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }

    .edit-wallet {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      .btn {
        background: #628808;
        color: white;
        font-size: 0.34rem;
        border-radius: 4px;
        width: 50%;
        height: 40px;
        margin: 0 0.1rem;
      }

      :nth-child(2) {
        background: #f6543e;
      }

      .btn:hover {
        background: #628808;
      }
    }

    .list {
      width: 97%;
      display: grid;
      grid-template-columns: 1fr 2%;
      align-items: center;
      margin: 10px auto;
      margin-top: 0;
      border-radius: 10px/10px;
      background-color: white;
      padding: 10px 10px;

      .des {
        display: grid;
        grid-template-columns: 36% 1fr 8%;
        padding: 1px 0;
        font-size: 0.34rem;

        :nth-child(1) {
          font-weight: bold;
          font-size: 0.34rem;
        }

        :nth-child(2) {
          overflow-wrap: break-word;
          max-width: 6rem;
        }

        button {
          color: brown;
        }
      }
    }
  }

  .edit-pard {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    background: rgb(235, 235, 235);
    font-size: 0.34rem;

    .edit-head {
      height: 1rem;
      display: grid;
      grid-template-columns: 30% 1fr 30%;
      align-items: center;
      text-align: center;
      font-size: 0.34rem;
      color: black;
      font-weight: bold;

      :nth-child(1) {
        cursor: pointer;

        img {
          display: block;
          margin-left: 5%;
          width: 0.5rem;
          transform: rotate(180deg);
        }
      }
    }

    .edit-content {
      position: absolute;
      margin: auto;
      height: 300px;
      width: 96%;
      left: 50%;
      transform: translateX(-50%);

      ul li {
        margin-bottom: 6px;

        input {
          width: 100%;
          border-radius: 10px/10px;
          border: solid 1px rgb(225, 225, 225);
          padding-left: 144px;
          height: 40px;
        }

        .icon-input {
          position: absolute;
          width: 144px;
          height: 40px;
          display: flex;
          align-items: center;
          font-weight: bold;
          padding-left: 4px;
        }

        button {
          width: 100%;
          border-radius: 4px;
          font-size: 0.34rem;
          height: 40px;
        }

        .btn-submit {
          background: #628808;
          color: white;
        }

        .btn-submit:hover {
          background: #628808;
        }
      }
    }
  }
}</style>  